export type ExternalDateSync = 'in-sync' | 'out-of-sync';

const EXTERNAL_DATE_SYNC_TOLERANCE_DAYS = 14;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function externalDateSync(
  nativeDate: string | null | undefined,
  externalDate: string | null | undefined,
): ExternalDateSync | undefined {
  if (!externalDate) {
    return undefined;
  }
  // In sync = at most 14 calendar days apart, either way (WI #5726).
  // Compares only the YYYY-MM-DD prefixes, which parse as UTC dates, so the
  // time of day and DST switches never count. Boundary behavior is intended:
  // 14 days → in-sync, 15 → out-of-sync; Dec 31 vs Jan 2 → in-sync,
  // Mar 1 vs Mar 31 → out-of-sync.
  const nativeDay = Date.parse((nativeDate ?? '').slice(0, 10));
  const externalDay = Date.parse(externalDate.slice(0, 10));
  if (Number.isNaN(nativeDay) || Number.isNaN(externalDay)) {
    return 'out-of-sync';
  }
  const daysApart = Math.abs(nativeDay - externalDay) / MS_PER_DAY;

  return daysApart <= EXTERNAL_DATE_SYNC_TOLERANCE_DAYS
    ? 'in-sync'
    : 'out-of-sync';
}
